//natives
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

//components
import Modal from "../childrens/modal/.mixins/Modal";
import Table from "../../../../Table/.mixins/Table";
import Error from "../../../../error/.mixins/Error";
import Filter from "../../../../filter/.mixins/Filter";

//css
import PedidosListaCss from './PedidosLista-css';
const useStyles = PedidosListaCss();

export default function PedidosLista(props) {
    const classes = useStyles();
    return (
        <div className="container">
            <Filter {...props}/>
            <br/>
            {props.state.isLoading &&
            <div align="center">
                <CircularProgress />
            </div>
            }
            {!props.state.isLoading && !props.state.isError &&
                <Table {...props} className={classes.root}/>
            }
            {props.state.isError &&
            <div align="center">
                <Error text={props.state.error}/>
            </div>
            }

        </div>
    );

}